import React from 'react'

const LeftArrow = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 6 9 12 15 18"></polyline>
        </svg>
    )
}

export default LeftArrow